export default __webpack_public_path__ + "static/entete-image-offre-ac17d650ebcd205b7844e0ecd451934d.jpg";